import api from './api';

// Get all users
const getUsers = async (queryParams = {}) => {
	const response = await api.get('/users', { params: queryParams });
	return response;
};

const usersService = {
	getUsers,
};

export default usersService;
